module.exports = __webpack_public_path__ + "img/HeyYou.a34c4cae.jpg";